import React from "react";
import "../Styles/LifestyleAndInterests.css";

const LifestyleAndInterests = ({
  habitList,
  selectedHabit,
  setSelectedHabit,
  hobbiesList,
  selectedHobbies,
  setSelectedHobbie,
}) => {
  
  // Toggle habit selection
  const handleHabitClick = (habitId) => {
    setSelectedHabit((prev) =>
      prev.includes(habitId)
        ? prev.filter((id) => id !== habitId) // remove if exists
        : [...prev, habitId] // add if not exists
    );
  };

  // Toggle hobby selection
  const handleHobbyClick = (hobbyId) => {
    setSelectedHobbie((prev) =>
      prev.includes(hobbyId)
        ? prev.filter((id) => id !== hobbyId)
        : [...prev, hobbyId]
    );
  };

  return (
    <div className="LifestyleAndInterests-form-container">
      <h2 className="LifestyleAndInterests-title">Habits</h2>

      <div className="LifestyleAndInterests-section">
        <div className="LifestyleAndInterests-options">
          {habitList.map((item) => (
            <button
              key={item.HabitId}
              type="button"
              onClick={() => handleHabitClick(item.HabitId)}
              className={`LifestyleAndInterests-option ${
                selectedHabit.includes(item.HabitId) ? "selected" : ""
              }`}
            >
              {item.HabitsName}
            </button>
          ))}
        </div>
      </div>

      <div className="LifestyleAndInterests-section">
        <label className="LifestyleAndInterests-label">
          Hobbies and Interests
        </label>
        <div className="LifestyleAndInterests-options">
          {hobbiesList.map((item) => (
            <button
              key={item.HobbiesId}
              type="button"
              onClick={() => handleHobbyClick(item.HobbiesId)}
              className={`LifestyleAndInterests-option ${
                selectedHobbies.includes(item.HobbiesId) ? "selected" : ""
              }`}
            >
              {item.HobbieName}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LifestyleAndInterests;
